import { createFeatureSelector, createSelector } from '@ngrx/store';
import { PaymentGeneratorReducer } from '../reducers';

export const selectPaymentGeneratorFeature = createFeatureSelector<PaymentGeneratorReducer.PaymentGeneratorState>(PaymentGeneratorReducer.featureName);

export const selectPaymentGenerator = createSelector(selectPaymentGeneratorFeature, (state: PaymentGeneratorReducer.PaymentGeneratorState) => state.item);
